import React, { Component, Fragment } from 'react';
import DEFINE, {HOTEL as ENUM_HOTEL, PATHS, FEATURE_FLAGS, CACHE_HOTEL_SEARCH_TYPE} from "../../../../constants/Define";
import { Link } from 'react-router-dom';
import * as Func from '../../../../helpers/functions';
import * as HMS from "../../common/component/Index";
import { Button, Icon, Rate, Modal } from 'antd';
import moment from 'moment'
import Ripple from '../../common/component/Ripple';
import AntSelect, { AntOption } from 'containers/backend/common/component/AntSelect';
import Wrapper from 'containers/backend/common/component/Wrapper';
import GolfList from './GolfList';

const { confirm } = Modal;

let permisionActions = [];
let permissionRate = [];
export default class Golf extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {
                pageSize: this.props.golfState.pageSize,
                pageNumber: this.props.golfState.pageNumber,
            },
            visibleClearCache: false,
            typeClearCache: 1,
        };
    }
    
    showModalClearCache = () => {
        this.setState({
            visibleClearCache: true,
        });
    };

    handleClearCacheOk = () => {
        this.props.clearCache(this.state.typeClearCache);
        this.setState({
            visibleClearCache: false,
        });
    };

    handleClearCacheCancel = () => {
        this.setState({
            visibleClearCache: false,
        });
    };

    onChangeType = (value) => {
        this.setState({
            typeClearCache: value
        })
    }

    componentDidMount() {
        // permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.GOLF_COURSE);
        // permissionRate = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.RATEPLAN);
        this.props.getListGolf(this.state.filters);
    }

    showConfirmSync = () => {
        const { t } = this.props;
        confirm({
            title: t('item.rate.titleSyncAll'),
            content: t('item.golf.messageSyncAll'),
            onOk: () => {
                const filters = {
                    pageSize: this.props.golfState.pageSize,
                    pageNumber: this.props.golfState.pageNumber,
                };
                this.props.syncAllGolf(filters);
            },
            onCancel() {},
            okText: t(`action.sync`),
            cancelText: t(`action.cancel`)
          });
    }

    render() {
        const { t } = this.props;
        const { isFetching, isFetchClearCache, totalCount, totalPage, pageNumber, pageSize, golfs } = this.props.golfState;
        const { isFetchSync, isFetchSyncAll } = this.props.rateState
        const { visibleClearCache, typeClearCache } = this.state;
        const pagination = {totalCount, totalPage, defaultCurrent: pageNumber, pageSize};

        return (
            <Fragment>
                <HMS.PageListComponent onChangeLanguage={FEATURE_FLAGS.TRANSLATE_ENABLE && this.onChangeLanguage}>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'vinpearlGolf'}
                        group={'golfCourse'}
                        titleHeader={t('navigation.golf')}
                        onClickTitle={() => this.props.history.push(PATHS.GOLF_COURSE.LIST.path)}
                        componentRight={
                            <Fragment>
                                <Wrapper style={{ display: 'flex' }}>
                                    <Wrapper>
                                    <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                            <Button
                                                icon="sync"
                                                loading={isFetchSyncAll}
                                                onClick={this.showConfirmSync}
                                                className='btn btn-primary'
                                            >
                                                {t(`action.sync`)}
                                            </Button>
                                        </Ripple>
                                    </Wrapper>
                                    {/* {
                                        permissionRate && permissionRate.allowSync &&
                                        <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                            <Button
                                                icon="sync"
                                                loading={isFetchSyncAll}
                                                onClick={this.showConfirmSync}
                                                className='btn btn-primary'
                                            >
                                                {t(`action.sync`)}
                                            </Button>
                                        </Ripple>
                                    } */}
                                </Wrapper>
                            </Fragment>
                        }
                    />
                    <GolfList loading={isFetching}
                        permisions={permisionActions}
                        permissionRate={permissionRate}
                        golf={golfs}
                        pagination={pagination}
                        onChange={this.onTableChange}
                        onDeleteGolf={this.onDeleteGolf}
                        syncGolf={this.props.syncAllGolf}
                        isFetchSync={isFetchSync}
                        updateGolfOrder={this.props.updateGolfOrder}
                        />
                </HMS.PageListComponent>
            </Fragment>
        );
    }

    onTableChange = (pagination, filters, sorter) => {
        let curfilters = this.state.filters;
        if (filters.status) {
            switch (filters.status[0]) {
                case 998:
                    filters = Func.removeElementObject(filters, 'status');
                    curfilters = Func.removeElementObject(curfilters, 'status');
                    curfilters = Func.removeElementObject(curfilters, 'isExpired');
                    filters.IsLocked = true;
                    break;
                case 999:
                    filters = Func.removeElementObject(filters, 'status');
                    curfilters = Func.removeElementObject(curfilters, 'status');
                    curfilters = Func.removeElementObject(curfilters, 'IsLocked');
                    filters.isExpired = true;
                    break;
                default:
                    if (filters.status[0] !== 998) { curfilters = Func.removeElementObject(curfilters, 'IsLocked') }
                    if (filters.status[0] !== 999) { curfilters = Func.removeElementObject(curfilters, 'isExpired') }
            }
        }
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);

        if (newFilters.hasOwnProperty('pageIndex')) {
            newFilters.pageNumber = newFilters.pageIndex;
            delete newFilters.pageIndex;
        }

        this.setState({
            filters: newFilters
        });

        this.props.getListGolf(newFilters);
    };

    onDeleteHotel = (hotelItem) => {
    }

    onChangeLanguage = (language) => {
        this.props.getListGolf(this.state.filters)
    }


}
